<div class="cat">

  <div class="head normal">
  </div>

  <div class="kitty-koerper"></div>
  <div class="tail waggle">
  </div>

</div>

<app-hearts></app-hearts>
